import * as f from "./fields";

import { ConsultantBookingContractType } from "@bonliva-crm/shared";

export const defaultFields = [f.contractType];

type ContractSchemaType = {
  [key in ConsultantBookingContractType]: typeof defaultFields | [];
};

export const contracts: ContractSchemaType = {
  [ConsultantBookingContractType.Outsource]: [
    f.contractType,
    f.responsiblePerson,
    f.profession,
    f.aoeSelector,
    f.customerSelector,
    f.departmentSelector,
    f.address,
    f.contactPerson,
    f.startDate,
    f.endDate,
    f.period,
    f.specificRequirements,
    f.pricesRecords,
    f.bonusRecords,
    f.priceRecruitment
  ],
  [ConsultantBookingContractType.Confirmation]: [
    f.contractType,
    f.responsiblePerson,
    f.customerSelector,
    f.departmentSelector,
    f.address,
    f.contactPerson,
    f.sithsCardNumber,
    f.callNumber,
    f.recipients,
    f.otherInfo,
    f.period,
    f.schedule,
    f.aoeSelector,
    f.price
  ]
};
// "Audionom",
// "Biomedicinsk analytiker",
// "Dietist",
// "Farmaceuter",
// "Internrekrytering",
// "Lärare",
